/** Compat shim — the light/dark boolean API, now derived from the preset
 *  appearance system. Existing callers (sidebar toggle, tests) keep working;
 *  new code should use useAppearance() from ./AppearanceProvider instead. */
import type { ReactNode } from "react";
import { AppearanceProvider, useAppearance } from "./AppearanceProvider";

export type ThemeMode = "light" | "dark";

export interface ThemeModeContextValue {
  mode: ThemeMode;
  setMode: (m: ThemeMode) => void;
  toggle: () => void;
}

export function useThemeMode(): ThemeModeContextValue {
  const { mode, setColorMode, toggleMode } = useAppearance();
  return {
    mode, // resolved light|dark
    setMode: (m) => setColorMode(m),
    toggle: toggleMode,
  };
}

export function ThemeModeProvider({ children }: { children: ReactNode }) {
  return <AppearanceProvider>{children}</AppearanceProvider>;
}
